import DevelopmentBar from "./development-bar";
import loginModalModule from "./login-modal/module";
import checkboxx from "./checkboxx";
import cookieCompliance from "./cookie-compliance";
import footerScripts from "./footer-scripts";
import AcceptTermsModule from "./accept-terms/module";
import ArticleDirectives from "./articles";
import BasketDirectives from "./basket/module";
import breadcrumb from "./breadcrumb";
import dateBox from "./date-box";
import FooterComponents from "./footer";
import Header from "./header";
import heroComponents from "./hero";
import NotificationsModule from "./notifications/module";
import pageSidebarModule from "./page-sidebar/module";
import asideModule from "./aside/module";
import SearchBarComponents from "./search-bar";
// import SearchResultComponents from "./search-results";
import ServiceBarComponents from "./service-bar";
import AccordianBasic from "./accordian-basic";
import ToggleSwitch from "./toggle-switch";
import ToggleRadioSwitch from "./toggle-radio-switch";
import SkipLinks from "./skip-links";

const modul = angular
    .module("components", [
        ArticleDirectives,
        BasketDirectives,
        SearchBarComponents,
        // SearchResultComponents,
        ServiceBarComponents,
        NotificationsModule,
        pageSidebarModule,
        Header,
        heroComponents,
        FooterComponents,
        cookieCompliance,
        footerScripts,
        asideModule,
        loginModalModule,
        AcceptTermsModule,
    ])

    .directive("accordianBasic", AccordianBasic)
    .directive("developmentBar", DevelopmentBar)
    .directive("checkboxx", checkboxx)
    .directive("toggleSwitch", ToggleSwitch)
    .directive("toggleRadioSwitch", ToggleRadioSwitch)
    .directive("breadcrumb", breadcrumb)
    .directive("skipLinks", SkipLinks)
    .directive("dateBox", dateBox);

export default modul.name;
